<template>
  <div>
    <AgentHeader :lead="lead" />

    <v-row>
      <v-col cols="9" class="plate">
        <slot />

        <template v-if="step !== PlatesSteps.summary">
          <PlateNeedDetails :lead="lead" :beneficiary="beneficiary" />

          <PlateHealthDetails />
        </template>
      </v-col>
      <v-col cols="3">
        <AgentSidebar :agent="agent" :lead="lead" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AgentHeader from '@/components/lead/AgentHeader';
import AgentSidebar from '@/components/lead/AgentSidebar';
import PlateHealthDetails from '@/components/lead/plates/PlateHealthDetails';
import PlateNeedDetails from '@/components/lead/plates/PlateNeedDetails';
import { PlatesSteps } from '@/common/variables';
import { mapGetters } from 'vuex';

export default {
  name: 'Plate',
  components: {
    AgentHeader,
    AgentSidebar,
    PlateHealthDetails,
    PlateNeedDetails,
  },
  props: {
    agent: Object,
    lead: Object,
    beneficiary: Object,
  },
  computed: {
    ...mapGetters({ step: 'plates/step' }),
  },
  data: () => ({
    PlatesSteps,
  }),
};
</script>

<style scoped>
.plate {
  padding: 20px 0 0 35px;
}
</style>
